import { useState } from "react"
import { cn } from "@/lib/utils"

interface CoverImageProps {
  src: string
  alt: string
  priority?: boolean
  className?: string
}

export function CoverImage({ src, alt, className }: CoverImageProps) {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div className={cn("relative aspect-video w-full overflow-hidden rounded-lg", className)}>
      <img
        src={src}
        alt={alt}
        className={cn("h-full w-full object-cover transition-all duration-300", isLoading ? "scale-105 blur-lg" : "scale-100 blur-0")}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  )
}
